import classNames from 'classnames';
import { memo } from 'react';

import styles from './index.less';

interface IProps {
  className?: string;
  dotItemClassName?: string;
}

function DotsLoading({ className, dotItemClassName }: IProps): JSX.Element {
  return (
    <div className={classNames(styles.dotsLoading, className)}>
      <div className={styles.dots}>
        <div className={classNames(styles.dotItem, dotItemClassName)} />
        <div className={classNames(styles.dotItem, dotItemClassName)} />
        <div className={classNames(styles.dotItem, dotItemClassName)} />
      </div>
    </div>
  );
}

export default memo(DotsLoading);
